export const GAS_ENERGY_COST_ID = 'gas';
export const EV_ENERGY_COST_ID = 'ev';
export const HOME_ENERGY_COST_ID = 'home';
